import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';


interface DataTableContainerProps {
    dataTable: React.ReactNode;
    pagination?: React.ReactNode;
}

export default function DataTableContainer(props: DataTableContainerProps) {
    const { styles } = useStyles(stylesheet);

    return <View style={{ flex: 1 }}>
        <View style={styles.cardList(Boolean(props.pagination))}>
            {props.dataTable}
        </View>
        {props.pagination &&
            <>{props.pagination}</>
        }
    </View>;
}

const stylesheet = createStyleSheet(theme => ({
    cardList: (hasPagination: boolean) => ({
        borderWidth: 1,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: hasPagination ? undefined : 8,
        borderBottomRightRadius: hasPagination ? undefined : 8,
        overflow: 'hidden',
        borderColor: theme.colors.dataTable.border,
        backgroundColor: theme.colors.dataTable.background,
        flex: 1,
    }),
}));
